import { Injectable } from '@angular/core';
import { Category } from './category.model';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  categoryData :Category;

  constructor(private firestore:AngularFirestore) { }

  getCategory(){
    return this.firestore.collection('category', x => x.orderBy('order', 'asc')).snapshotChanges();
  }
  getSingleCategory(id: string): Observable<Category[]>{
    return this.firestore.collection<Category>('category', x => x.orderBy('order', 'asc')).valueChanges();
  }
}
